module.exports = __webpack_public_path__ + "img/setting.7e970eab.svg";